module.exports = __webpack_public_path__ + "img/icon.c23fd63b.png";